function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "restaurants");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings",
  transform: "translate(-30.000000, -332.000000)",
  stroke: "#155C28"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection-Copy",
  transform: "translate(10.000000, 315.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "restaurants",
  transform: "translate(21.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.94361521,0 L7.61512096,3.67150576 C8.12829301,4.18483281 8.12829301,5.01693601 7.61512096,5.53026306 L5.53026306,7.61512096 C5.01693601,8.12829301 4.18483281,8.12829301 3.67150576,7.61512096 L0,3.94361521",
  id: "Path",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2,
  y1: 2,
  x2: 5,
  y2: 5,
  id: "Path",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 14,
  x2: 18,
  y2: 18,
  id: "Path",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 7,
  x2: 10,
  y2: 10,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,18 L18.7500901,1 C19.4504925,3.79019369 18.655488,6.74870172 16.6563289,8.79166667 C15.1143901,10.4251274 13.1953413,11.6424279 11.0729655,12.3333333",
  id: "Path",
  strokeLinecap: "square"
})))));

var SvgRestaurants = function SvgRestaurants(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestaurants, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restaurants.f317dd6b.svg";
export { ForwardRef as ReactComponent };